"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnitsCount = exports.UnitsNear = exports.UnitsWindowed = void 0;

var http_1 = require("./http");

var uri = '/v4/data/units/';

function default_1(time, limitExpression, fields, credentials) {
  var query = "";
  return http_1.authorizedHTTP(credentials).get(uri, {
    params: {
      time: Math.floor(time.getTime() / 1000),
      fields: fields.join(","),
      q: limitExpression
    },
    headers: {
      'Authorization': 'Bearer ' + credentials.token()
    }
  }).then(function (resp) {
    return resp.data;
  });
}

exports.default = default_1;

function UnitsWindowed(limitExpression, fields, order, limit, offset, credentials) {
  var query = "";
  return http_1.authorizedHTTP(credentials).get(uri, {
    params: {
      fields: fields.join(","),
      q: limitExpression,
      order: order,
      limit: limit,
      offset: offset
    }
  }).then(function (resp) {
    return resp.data;
  });
}

exports.UnitsWindowed = UnitsWindowed;

function UnitsNear(limitExpression, fields, lat, lng, limit, offset, credentials) {
  return http_1.authorizedHTTP(credentials).get(uri + "/near/" + lat + "/" + lng, {
    params: {
      fields: fields.join(","),
      q: limitExpression,
      limit: limit,
      offset: offset
    }
  }).then(function (resp) {
    return resp.data;
  });
}

exports.UnitsNear = UnitsNear;

function UnitsCount(limitExpression, credentials) {
  var query = "";
  return http_1.authorizedHTTP(credentials).get(uri + "count", {
    params: {
      q: limitExpression
    }
  }).then(function (resp) {
    return resp.data;
  });
}

exports.UnitsCount = UnitsCount;
/*
assetid: "735999124000897210 - Z3s2"
channel: "krogoth_stable"
giai: "6430057730000371"
lastseen: "2018-11-08T09:37:30Z"
location: {name: "25373 HBG, Electricity meter", address: "Murkelgatan 5, Helsingborg", lat: 56.04650115966797, lng: 12.694499969482422, geoname: "Sweden/Scania/Helsingborg", …}
meter: {meterid: "42494493", code: "/LGZ5ZMF100AC.M29", manufacturer: "Landis+Gyr AG Zug", customerID: "2383198", time: "0001-01-01T00:00:00Z", …}
model: "Z3s2"
profile: 3
profileversion: 2
status: {status: "idle", time: "2018-11-08T09:37:39Z"}
time: "2018-11-08T09:37:30Z"
uuid: "e626ca47-0da5-42ce-8136-ba09f99f411b"
version: "krogoth:1.5.2:1.2.1-2-gadb15ba"
*/